
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/Top-8-Christmas-Stocking-Fillers-2022",
      function () {
        return require("private-next-pages/blog/Top-8-Christmas-Stocking-Fillers-2022.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/Top-8-Christmas-Stocking-Fillers-2022"])
      });
    }
  